import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'page-dish-view-print-label',
    templateUrl: 'dish-view-print-label.html',
})
export class DishViewPrintLabelPage {
    @Input() dish: any;
    @Input() elaboration_date: any;
    @Input() consumption_date: any;
    @Input() lote: any;
    @Input() show_price: any;
    @Input() show_logo: any;
    @Input() show_nutrition: any;
    @Input() show_traces: any;
    footer: any;
    header: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public translate: TranslateService) {

    }

    getAllergens(allergens) {
        if (allergens) {
            var _allergens_text = ' ';
            for (let allergen of allergens) {
                _allergens_text += this.globals.getAllergenName(allergen).replace('*', '') + ', ';
            }
            _allergens_text = _allergens_text.substring(0, _allergens_text.length - 2);
            return _allergens_text;
        } else {
            return '';
        }

    }


    getIngredients(ingredients) {
        if (ingredients) {
            var _ingredients_text = ' ';
            for (let ingredient of ingredients) {
                _ingredients_text += ingredient.name_static + ', ';
            }
            _ingredients_text = _ingredients_text.substring(0, _ingredients_text.length - 2);
            return _ingredients_text;
        } else {
            return '';
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-print-label/dish-view-print-label.ts